module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main